import { styled, TextField as MuiTextField, Theme } from "@mui/material";

/**
 * Settings of the legacy form fields (see legacy/config/theme.legacy.ts and
 * legacy/components/UpInput) that have no equivalent in the MUI palette.
 */
const LEGACY_INPUT_BORDER = "#EFEFEF80";
const LEGACY_INPUT_FOCUS = "#c2e5e7";
const LEGACY_ERROR_BORDER = "#AC231D";
const LEGACY_PLACEHOLDER = "#aaa";
const LEGACY_FONT_SIZE = "14px";

export const makePaperStyles = ({ palette: { custom } }: Theme) => ({
  backgroundColor: custom.grey.main,
  borderRadius: "3px",
  color: custom.white.main,

  "& .MuiAutocomplete-noOptions": {
    color: custom.white.main,
    padding: "10px"
  },

  "& .MuiAutocomplete-listbox": {
    maxHeight: "250px",
    padding: 0,

    "& .MuiAutocomplete-option": {
      padding: "10px",
      color: custom.white.main,

      "&.Mui-focused": {
        background: custom.grey.light
      },

      '&[aria-selected="true"]': {
        background: custom.turquoise.light,

        "&.Mui-focused": {
          background: custom.turquoise.light
        }
      }
    },

    "&::-webkit-scrollbar": {
      width: "4px"
    },

    "&::-webkit-scrollbar-track": {
      background: custom.grey.main
    },

    "&::-webkit-scrollbar-thumb": {
      background: custom.white.light,
      borderRadius: "2px",

      "&:hover": {
        background: custom.white.main
      }
    }
  }
});

export const CountryTextField = styled(MuiTextField)(
  ({
    theme: {
      palette: { custom },
      typography: { body1 }
    }
  }) => `
    & .MuiInputBase-root {
      height: 36px;
      padding: 7px 30px 7px 10px;
      border-radius: 3px;
      background: ${custom.grey.main};
      color: ${custom.white.main};
      font-size: ${LEGACY_FONT_SIZE};
      line-height: ${body1.desktop.lineHeight};
      font-weight: ${body1.desktop.fontWeight};

      & .MuiInputBase-input {
        padding: 0;
        color: inherit;

        &::placeholder {
          color: ${LEGACY_PLACEHOLDER};
          opacity: 1;
        }
      }

      & .MuiOutlinedInput-notchedOutline {
        border: 1px solid ${LEGACY_INPUT_BORDER};
        border-radius: 3px;
      }

      &:hover .MuiOutlinedInput-notchedOutline {
        border-color: ${LEGACY_INPUT_BORDER};
      }

      &.Mui-focused .MuiOutlinedInput-notchedOutline {
        border: 1px solid ${LEGACY_INPUT_FOCUS};
        box-shadow: 0px 0px 5px ${LEGACY_INPUT_FOCUS};
      }

      & .MuiAutocomplete-endAdornment {
        top: 18px;

        & .MuiAutocomplete-popupIndicator,
        & .MuiAutocomplete-clearIndicator {
          color: ${custom.white.main};
          padding: 2px;

          &:hover {
            background: none;
            color: ${custom.turquoise.main};
          }
        }
      }

      &.Mui-error {
        background: ${custom.coral.main};

        & .MuiOutlinedInput-notchedOutline,
        &.Mui-focused .MuiOutlinedInput-notchedOutline {
          border-color: ${LEGACY_ERROR_BORDER};
          box-shadow: none;
        }

        /* leave room for the error icon rendered by UpFieldWithErrorState */
        & .MuiAutocomplete-endAdornment {
          right: 22px;
        }
      }

      &.Mui-disabled {
        background: ${custom.white.dark};

        & .MuiInputBase-input {
          -webkit-text-fill-color: ${custom.white.main};
        }
      }
    }
  `
);
